import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=63d13cea&scoped=true"
import script from "./GeneralSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSetting.vue?vue&type=script&lang=js"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=63d13cea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d13cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d13cea')) {
      api.createRecord('63d13cea', component.options)
    } else {
      api.reload('63d13cea', component.options)
    }
    module.hot.accept("./GeneralSetting.vue?vue&type=template&id=63d13cea&scoped=true", function () {
      api.rerender('63d13cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/general/components/GeneralSetting.vue"
export default component.exports